import React from 'react';
import Accordion from './Accordion';

const Modal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="modal fixed inset-0 bg-black opacity-50"></div>
            <div className="modal-content bg-white rounded-lg shadow-lg z-10 lg:w-[40%] w-[90%]">
                <div className="modal-header flex justify-between p-4">
                    <h2 className="text-2xl font-semibold">License Information</h2>
                    <button className="text-gray-600 hover:text-gray-800 text-xl" onClick={onClose}>
                        ×
                    </button>
                </div>
                <hr />
                <div className="modal-body p-5">
                    <>
                        <Accordion />
                    </>
                </div>
            </div>
        </div>
    );
};

export default Modal;
